import 'css-chunksrc/client/scenes/projectGroupCreation/groupCreationForm/resourcesList/styles.scss';export default {
  "resourcesList": "_resourcesList_wonyy_1",
  "title": "_title_wonyy_9",
  "group": "_group_wonyy_17",
  "resourceForm": "_resourceForm_wonyy_21",
  "resources": "_resources_wonyy_1",
  "resource": "_resource_wonyy_1",
  "addResourceButton": "_addResourceButton_wonyy_39",
  "marginForm": "_marginForm_wonyy_46"
};